import { DRAWER_CONTEXT_PREFIX } from './askAIContextMarkers'

/** True when the prior user turn was an Ask AI context submit (plain text/links/pills only). */
export function userMessagePrefersPlainAssistantUi(rawContent: string | undefined): boolean {
  if (!rawContent) return false
  if (rawContent.includes(DRAWER_CONTEXT_PREFIX)) return true
  if (rawContent.includes('The user is asking about ')) return true
  if (rawContent.includes('Ask AI about ')) return true
  return false
}
